import { Avatar } from '@mui/material';
import React from 'react';
import KyronAvatar from 'assets/kyron_avatar.svg';

const ROLE_AI: string = 'Kyron';
export function OpenEndedChatAvatar({ role }: { role: string }) {
  if (role !== ROLE_AI)
    return (
      <Avatar alt={role} sx={{ width: 32, height: 32 }}>
        {role[0]}
      </Avatar>
    );
  if (role === ROLE_AI) return <img src={KyronAvatar} alt='Kyron Avatar' data-testid='kyron-avatar' />;
}
